import React,{useState} from "react";
import icone from '../campos/imagens/menu.png'
import fecharicone from '../campos/imagens/fecharmenu.png'
import './Siderbar.css'

function Sidebar(props) {

    const [MostrarSidebar, setMostrarSidebar] = useState(false);

    return(
        <div className="">
            <div className="campo1">
                <div className={MostrarSidebar ? "campo2true" : "campo2false"}>
                    <div>
                        <h3 className="sidebar-subtitulo">{props.subTitulo}</h3>
                        <div className="teste">
                            <h1 className="sidebar-titulo">{props.Titulo}</h1>
                        </div>
                        <p className="descricao">{props.children}</p>
                        
                        <button onClick={() => {setMostrarSidebar(!MostrarSidebar)}} 
                                className='close drop-shadow-xl'>
                                <b>x</b>
                        </button>
                    </div>
                </div>
                <button onClick={() => {setMostrarSidebar(!MostrarSidebar)}}
                        className={MostrarSidebar ? "btn_aberto" : "btn_fechado"}>
                    <img src={MostrarSidebar ? fecharicone : icone}/>
                </button>
                
            </div>
        </div>
)}

export default Sidebar;